// removed by extract-text-webpack-plugin
module.exports = {"tab":"src-components-Tab----tab-module---tab---tA_rJ","activeTab":"src-components-Tab----tab-module---activeTab---sKFsF","smallTab":"src-components-Tab----tab-module---smallTab---26HLV","largeTab":"src-components-Tab----tab-module---largeTab---2G30q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tab/tab.module.scss
// module id = 343
// module chunks = 152909308826437